import React from "react";
import Footer from "../components/Footer/Footer";
import Navbar from "../components/Navbar/Navbar";
import Hero3 from "../components/Hero3/Hero3";
import CoreVirtuesValues from "../components/CoreVirtuesValues/CoreVirtuesValuesWhite";
import HeroImg from "../assets/joinusheroimg.png";
import JoinUsSection1 from "../components/JoinUs/JoinUsSection1/JoinUsSection1";
import SEO from "../components/SEO";
import { useTranslation } from "react-i18next";

const JoinUs = () => {
  const { t } = useTranslation("global");
  return (
    <>
      <SEO slug="JoinUs" />
      <Navbar />
      <Hero3
        heading={t("pages.joinUs.heading")}
        heading2={t("pages.joinUs.heading2")}
        paragraph={t("pages.joinUs.paragraph")}
        imageSrc={HeroImg}
      />
      <div style={{ backgroundColor: "#FFF5EC" }}>
        {" "}
        <JoinUsSection1 />
        <CoreVirtuesValues />
      </div>

      <Footer />
    </>
  );
};

export default JoinUs;
